import React from "react";

// Pill button using the shared .btn styles (add "primary", "btn-ghost", ... for variants)
const Button = ({ children, onClick, className = "", type = "button", ...rest }) => {
  return (
    <button type={type} className={`btn ${className}`} onClick={onClick} {...rest}>
      {children}
    </button>
  );
};

export default Button;
